import PropTypes from 'prop-types'
import React from 'react'
import { injectIntl } from 'react-intl'
import NumericStepper from '@vtex/styleguide/lib/NumericStepper'
import Delete from '@vtex/styleguide/lib/icon/Delete'
import Failure from '@vtex/styleguide/lib/icon/Failure'

import { intlShape } from '@/checkout-instore-legacy/i18n/intlShape'
import SkuLabelRow from './SkuLabelRow'
import Price from '@/checkout-instore-legacy/components/Commons/Price'
import ProductImage from '@/checkout-instore-legacy/components/Commons/ProductSummary/ProductImage'

function borderClassesFromIndex(index, length) {
  const isFirst = index === 0
  const isLast = index === length - 1
  if (!isFirst && !isLast) {
    return 'bt b--muted-4'
  }
  if (isFirst && isLast) {
    return 'br2'
  }
  if (isFirst && !isLast) {
    return 'br2 br--top'
  }
  if (!isFirst && isLast) {
    return 'br2 br--bottom bt b--muted-4'
  }
}

function ItemCard({
  index,
  length,
  showPrice,
  ean,
  skuSpecifications,
  imageSrc,
  productName,
  orderItemInconsistency,
  itemQuantity,
  maxQuantity,
  value,
  handleChangeItemQuantity,
  handleRemoveItem,
}) {
  const isLast = index === length - 1
  return (
    <div className="relative">
      {orderItemInconsistency && (
        <div className="absolute c-danger z-2 left-1 top-1">
          <Failure size={18} />
        </div>
      )}
      <div
        className={`flex flex-row justify-between bg-base c-on-base ${borderClassesFromIndex(
          index,
          length
        )} ${isLast ? 'mb5' : ''}`}
        style={{
          boxShadow: '0px 2px 2px rgba(0, 0, 0, 0.05)',
        }}
      >
        <div
          className={`flex flex-row mh4 pv1  ${
            orderItemInconsistency ? 'o-60' : ''
          }`}
        >
          <div className="relative">
            <ProductImage src={imageSrc} />
          </div>
          <div className="flex flex-column pl5 pt5 justify-between">
            <div>
              <span className="fw4">{productName}</span>
              <SkuLabelRow skuSpecifications={skuSpecifications} />
            </div>
            {showPrice && <Price className="fw7 f5 f4-ns pb5" value={value} />}
          </div>
        </div>
        <div className="flex flex-column justify-between ">
          {handleRemoveItem && (
            <div className="flex flex-row justify-end items-end pt5 pr6">
              <div
                className="self-end c-action-primary pointer"
                onClick={() => handleRemoveItem(ean)}
              >
                <Delete />
              </div>
            </div>
          )}
          {handleChangeItemQuantity && (
            <div
              className="pr4 pb5"
              style={{
                width: '8rem',
              }}
            >
              <NumericStepper
                block
                lean
                minValue={1}
                value={itemQuantity}
                onChange={(e) => handleChangeItemQuantity(ean, e.value)}
                maxValue={maxQuantity || Number.MAX_SAFE_INTEGER}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

ItemCard.defaultProps = {
  skuSpecifications: [],
}

ItemCard.propTypes = {
  canEdit: PropTypes.bool,
  showPrice: PropTypes.bool,
  productName: PropTypes.string.isRequired,
  skuSpecifications: PropTypes.array,
  imageSrc: PropTypes.string.isRequired,
  orderItemInconsistency: PropTypes.bool,
  value: PropTypes.number,
  ean: PropTypes.string.isRequired,
  index: PropTypes.number,
  length: PropTypes.number,
  itemQuantity: PropTypes.number,
  maxQuantity: PropTypes.number,
  handleChangeItemQuantity: PropTypes.func,
  handleRemoveItem: PropTypes.func,
  intl: intlShape,
}

export default injectIntl(ItemCard)
